<template>
	<div  >
		<main>
			<router-view />
		</main>
		<Footer />
	</div>
</template>

<script>
import Footer from '../components/Footer';

export default {
	name: 'Base',
	components: {
		Footer
	}
};
</script>
